<template align="center">
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <b-row>
        <b-col sm="2">
          <span>Last System Pattern</span>
        </b-col>
        <b-col sm="2">
          <span v-if="pattern" >{{ pattern.created_at | datetime}}</span>
          <span v-else >-</span>
        </b-col>
        <b-col sm="2">
          <span v-if="pattern" >{{ codes.code_type[pattern.type || ''] }}</span>
        </b-col>
        <b-col sm="6">
          <span v-if="pattern" >{{ pattern.code | truncate(50) }}</span>
          <span v-else >-</span>
        </b-col>
      </b-row>
    </b-card>
      <b-card border-variant="primary">
      <template slot="header">
        <i class='fa fa-align-justify'></i> Detection TOP {{so.perPage}}
      </template>
      <span class="text-center" v-b-tooltip.hover title="can see the log real-time">
          Real-time refresh interval
          <select v-model="sync.interval" @change="refresh">
            <option disabled value="15">Please select interval : Default 15</option>
            <option value=10>10</option>
            <option value=30>30</option>
            <option value=60>60</option>
            <option value=300>300(5 min)</option>
          </select>
          sec
        </span>
        <span class="float-right">
          <i :class="`fa fa-refresh ${sync.th && !sync.stop ? 'fa-spin' : ''}`"></i>
          <b-btn @click="pause" size="sm" variant="warning">Pause</b-btn>
        </span>
      <hr>
      <b-row>
        <b-col sm="6">
          Show count
          <select v-model="so.perPage" @change="refresh">
            <option disabled value="15">Show count : Default 15</option>
            <option value=10>10</option>
            <option value=50>50</option>
            <option value=100>100</option>
          </select>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='remote_addr';so.skt=`Attacker`">Attacker</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='target';so.skt=`Target`">Target</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='message';so.skt='Rule'">Rule</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='uri';so.skt='URI'">URI</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = true; set()"><i class="fa fa-search-plus"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list"
        show-empty empty-text="not found"
        :items="load" :fields="f_detect" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
        <template slot="group" slot-scope="row">{{row.item.id}}</template>
        <template slot="agent" slot-scope="row">{{`${row.item.agent.name}@${row.item.agent.ip_addr}`}}</template>
        <template slot="category" slot-scope="row">{{row.item.category}}</template>
        <template slot="path" slot-scope="row">{{row.item.path}}</template>

        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
        </template>
      </b-table>
    </b-card>

    <router-view ></router-view>
  </div>
</template>

<script>
import * as _ from 'lodash'
import { Api } from '@/service';
import codes from '@/codes'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv : false,
});

export default {
	data: () => {
		return {
      codes,
      pattern : undefined,
      show: true,
      sync : { interval : 15, stop : false, th : undefined },
      so : default_opt(),
    }
  },
  computed: {
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    },
    f_detect() {
      return [
      { key: 'created_at', label: 'Date', sortable: false, thStyle: 'width: 10%' },
      { key: 'group', label: 'Company', sortable: false, thStyle: 'width: 10%' },
      { key: 'agent', label: 'Agent', sortable: false, thStyle: 'width: 10%' },
      { key: 'category', label: 'Rule', sortable: false, thStyle: 'width: 10%' },
      { key: 'path', label: 'Path', sortable: false },
    ]}
  },
	methods: {
    getPattern() {
      // recent system pattern
      let so = Object.assign({}, this.so, { target : 'wsfinder.pattern', cmd : 'list', offset : 0, limit : 1, body : {
        columns : ["type", "created_at"], sort : [{ name : 'id', op : 'desc' }],
        // and : [{ name : 'is_alive', op :  '=', value : true }] // option
      } })
      Api.Manager(so).then(rs => { this.pattern = rs.body ? rs.body[0] : null; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    refresh() {
      if((!this.sync.stop || this.so.adv) && this.$refs._list) {
        this.$refs._list.refresh(); console.log('wsfinder log refresh', new Date());
      }
    },
    load(ctx = {}) {
      let so = {
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {},
        target : 'wsfinder.detect',
        cmd : 'list',
        offset : this.so.currentPage-1 || 0,
        limit :  Number(this.so.perPage),
        body: {
          and : [],
          sort : [ { name : "id", op : "desc" } ]
        }
      }
      so.offset = so.offset * so.limit;

      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }

      return Api.Manager(so).then(rs => {
        this.so.totalRows = rs.total;
        return rs.body;
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    pause: function() { this.sync.stop = !this.sync.stop; this.refresh(); if(this.sync.stop) { this.so.adv = false; } },
	},
  created: function() { console.log('WSFinder', 'dashboard.vue', 'created'); },
  destroyed: function() { console.log('WSFinder', 'dashboard.vue', 'destroyed'); clearTimeout(this.sync.th); this.sync.th = undefined; },
  mounted: function() { console.log('WSFinder', 'dashboard.vue', 'mounted'); this.getPattern() },
}
</script>
